import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { AvField, AvForm, AvInput } from 'availity-reactstrap-validation';
import SweetAlert from 'react-bootstrap-sweetalert';
import Select from 'react-select';
import { Alert, Button, Card, CardBody, CardTitle, Col, FormGroup, Label, UncontrolledTooltip } from 'reactstrap';

import { createPlcSafetyEvent, getPlcSafetyZones } from '../../store/actions';

const ACTION_OPTIONS = ['STOP_ZONE', 'EVACUATE_ZONE'];

class CreatePlcSafetyEventForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      // P01021-135: la acción es por zona, no por evento — el cliente dio dos ejemplos reales
      // asimétricos (una zona se para en un evento pero no en otro) que una única acción por
      // evento no podía expresar. zoneActions: { [zone_code]: 'STOP_ZONE'|'EVACUATE_ZONE'|null }
      zoneActions: {},
      ledScope: 'NONE',
      ledState: 'FLASHING',
      isCycleStart: false,
      broadcastZoneFixed: false,
      selectedZones: [],
      selectedInvokableZones: [],
      targetZoneCode: null,
      popup: false,
      pop_msg: null,
      pop_err: null,
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidMount() {
    this.props.getPlcSafetyZones(this.state.user);
  }

  componentDidUpdate(prevProps) {
    const { messagePlcSafetyEvent, createPlcSafetyEventError, loadingCreatePlcSafetyEvent } = this.props;
    if (loadingCreatePlcSafetyEvent === false && prevProps.loadingCreatePlcSafetyEvent === true) {
      if (messagePlcSafetyEvent) {
        this.setState({ popup: true, pop_msg: 'Evento creado correctamente' });
      } else if (createPlcSafetyEventError) {
        this.setState({ popup: true, pop_err: createPlcSafetyEventError.message || 'No se ha podido crear el evento' });
      }
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
    if (this.state.pop_msg) this.props.history.push('/plcSafetyEvents');
  }

  setZoneAction(zoneCode, action) {
    this.setState((prevState) => ({
      zoneActions: { ...prevState.zoneActions, [zoneCode]: action || null },
    }));
  }

  hasEvacuateZone() {
    return Object.values(this.state.zoneActions).includes('EVACUATE_ZONE');
  }

  selectedZoneOptions() {
    return [...this.state.selectedZones, ...this.state.selectedInvokableZones];
  }

  handleValidSubmit(event, values) {
    const user = this.state.user;
    values.led_scope = this.state.ledScope;
    values.led_state = this.state.ledScope === 'NONE' ? null : this.state.ledState;
    values.is_cycle_start = this.state.isCycleStart;
    values.broadcast_zone_fixed = this.state.broadcastZoneFixed;
    values.zones = this.selectedZoneOptions().map((z) => ({
      zone_code: z.value,
      action: this.state.zoneActions[z.value] || null,
    }));
    values.target_zone_code = this.hasEvacuateZone() ? this.state.targetZoneCode?.value : null;
    values.token = user.token;
    this.props.createPlcSafetyEvent(values);
  }

  render() {
    const allZones = this.props.zones || [];
    // El cliente confirmó que RCS solo acepta parar/evacuar/bloquear directamente contra las
    // zonas invocables (map_zones.api_invokable=1) — se separan en dos selectores para que
    // quede claro cuál es cuál al configurar un evento (el resto de zonas del array son solo
    // bookkeeping interno de TPS: cause_zones/LEDs).
    const invokableZoneOptions = allZones
      .filter((z) => Number(z.api_invokable) === 1)
      .map((z) => ({ value: z.zone_code, label: z.zone_name }));
    const zoneOptions = allZones
      .filter((z) => Number(z.api_invokable) !== 1)
      .map((z) => ({ value: z.zone_code, label: z.zone_name }));
    return (
      <Col lg="12">
        <Card>
          <CardBody>
            <CardTitle className="mb-4">{this.props.t('Crear evento PLC Safety')}</CardTitle>
            <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
              <Col>
                <FormGroup>
                  <Label htmlFor="eventName">{this.props.t('Nombre')}</Label>
                  <AvField
                    name="name"
                    placeholder={this.props.t('Nombre')}
                    type="text"
                    errorMessage="Introduzca un nombre válido"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="eventName"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="eventDescription">{this.props.t('Descripción')}</Label>
                  <AvField name="description" type="text" className="form-control" id="eventDescription" />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="eventIsCycleStart"
                      checked={this.state.isCycleStart}
                      onChange={(e) => this.setState({ isCycleStart: e.target.checked })}
                    />
                    <label className="form-check-label" htmlFor="eventIsCycleStart">
                      {this.props.t('Es un inicio de ciclo (no crea causa, solo desbloquea la zona)')}
                    </label>
                  </div>
                </FormGroup>
              </Col>
              {this.state.isCycleStart ? (
                <Alert color="info">
                  {this.props.t(
                    'Un evento de inicio de ciclo no crea causas ni gestiona LEDs directamente — el trigger que lo apunte (p. ej. telegramType=SC, action=1) disparará la restauración de las zonas seleccionadas abajo en cuanto no quede ninguna causa activa/rearmada bloqueándolas. Si el identificador del telegrama cambia en el futuro, basta con editar el trigger — no hace falta tocar código.',
                  )}
                </Alert>
              ) : null}
              {!this.state.isCycleStart && this.hasEvacuateZone() ? (
                <Col>
                  <FormGroup>
                    <Label htmlFor="eventTargetZone">
                      {this.props.t('Zona destino de la evacuación (invocable en RCS)')}
                    </Label>
                    <Select
                      id="eventTargetZone"
                      placeholder={this.props.t('Seleccionar zona destino')}
                      value={this.state.targetZoneCode}
                      onChange={(selected) => this.setState({ targetZoneCode: selected || null })}
                      options={invokableZoneOptions}
                    />
                    <small className="form-text text-muted">
                      {this.props.t(
                        'A qué zona invocable de RCS se llevarán los robots evacuados (targetZoneCode del banish) — obligatorio.',
                      )}
                    </small>
                  </FormGroup>
                </Col>
              ) : null}
              {!this.state.isCycleStart ? (
                <Col>
                  <FormGroup>
                    <Label htmlFor="eventLedScope">{this.props.t('Alcance del indicador')}</Label>
                    <AvInput
                      value={this.state.ledScope}
                      name="led_scope"
                      type="select"
                      className="form-control"
                      id="eventLedScope"
                      onChange={(e) => this.setState({ ledScope: e.target.value })}
                    >
                      <option value="NONE">{this.props.t('Ninguno')}</option>
                      <option value="SIDE">{this.props.t('Un lado')}</option>
                      <option value="STATION">{this.props.t('Ambos lados de la estación')}</option>
                      <option value="ZONE">{this.props.t('Toda la zona')}</option>
                    </AvInput>
                  </FormGroup>
                </Col>
              ) : null}
              {!this.state.isCycleStart && this.state.ledScope !== 'NONE' ? (
                <>
                  <Col>
                    <FormGroup>
                      <Label htmlFor="eventLedState">{this.props.t('Estado del indicador')}</Label>
                      <AvInput
                        value={this.state.ledState}
                        name="led_state"
                        type="select"
                        className="form-control"
                        id="eventLedState"
                        onChange={(e) => this.setState({ ledState: e.target.value })}
                      >
                        <option value="FLASHING">{this.props.t('Parpadeante')}</option>
                        <option value="FIXED">{this.props.t('Fijo')}</option>
                      </AvInput>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label htmlFor="eventLedColor">{this.props.t('Color')}</Label>
                      <AvField name="led_color" type="text" className="form-control" value="red" id="eventLedColor" />
                    </FormGroup>
                  </Col>
                </>
              ) : null}
              {!this.state.isCycleStart ? (
                <Col>
                  <FormGroup>
                    <div className="form-check d-flex align-items-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="eventBroadcastZoneFixed"
                        checked={this.state.broadcastZoneFixed}
                        onChange={(e) => this.setState({ broadcastZoneFixed: e.target.checked })}
                      />
                      <label className="form-check-label mb-0" htmlFor="eventBroadcastZoneFixed">
                        {this.props.t('Poner en rojo fijo el resto de posiciones de las zonas seleccionadas')}
                      </label>
                      <i
                        className="mdi mdi-information text-info ml-2"
                        id="broadcastZoneFixedInfo"
                        style={{ cursor: 'pointer', fontSize: '20px' }}
                      ></i>
                      <UncontrolledTooltip placement="top" target="broadcastZoneFixedInfo">
                        {this.props.t(
                          'La posición propia del elemento sigue el alcance/estado configurado arriba; el resto de posiciones de las zonas seleccionadas abajo se pondrán en rojo fijo mientras esta causa esté activa o rearmada sin resolver. Requiere al menos una zona seleccionada.',
                        )}
                      </UncontrolledTooltip>
                    </div>
                  </FormGroup>
                </Col>
              ) : null}
              <Col>
                <FormGroup>
                  <Label htmlFor="eventInvokableZones">{this.props.t('Zonas afectadas — invocables en RCS')}</Label>
                  <Select
                    id="eventInvokableZones"
                    isMulti
                    placeholder={this.props.t('Seleccionar zonas invocables')}
                    value={this.state.selectedInvokableZones}
                    onChange={(selected) => this.setState({ selectedInvokableZones: selected || [] })}
                    options={invokableZoneOptions}
                  />
                  <small className="form-text text-muted">
                    {this.props.t(
                      'Las que RCS acepta invocar directamente para parar/bloquear/evacuar (map_zones.api_invokable=1).',
                    )}
                  </small>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="eventZones">
                    {this.props.t('Zonas afectadas — resto (no invocables en RCS, solo LEDs/registro)')}
                  </Label>
                  <Select
                    id="eventZones"
                    isMulti
                    placeholder={this.props.t('Seleccionar zonas')}
                    value={this.state.selectedZones}
                    onChange={(selected) => this.setState({ selectedZones: selected || [] })}
                    options={zoneOptions}
                  />
                </FormGroup>
              </Col>
              {!this.state.isCycleStart && this.state.selectedInvokableZones.length > 0 ? (
                <Col>
                  <FormGroup>
                    <Label>{this.props.t('Acción por zona')}</Label>
                    <small className="form-text text-muted mb-2">
                      {this.props.t(
                        'Solo zonas invocables en RCS — el resto (estaciones) no tiene ninguna acción real que configurar aquí, solo se usan para LEDs.',
                      )}
                    </small>
                    {this.state.selectedInvokableZones.map((z) => (
                      <div className="d-flex align-items-center mb-1" key={z.value}>
                        <span className="mr-2" style={{ minWidth: '160px' }}>
                          {z.label}
                        </span>
                        <select
                          className="form-control"
                          style={{ maxWidth: '220px' }}
                          value={this.state.zoneActions[z.value] || ''}
                          onChange={(e) => this.setZoneAction(z.value, e.target.value || null)}
                        >
                          <option value="">{this.props.t('Sin acción')}</option>
                          {ACTION_OPTIONS.map((action) => (
                            <option key={action} value={action}>
                              {action}
                            </option>
                          ))}
                        </select>
                      </div>
                    ))}
                  </FormGroup>
                </Col>
              ) : null}
              <Button color="secondary" type="submit">
                {this.props.t('Crear evento')}
              </Button>
            </AvForm>
            {this.state.popup ? (
              <SweetAlert
                type={this.state.pop_msg ? 'success' : 'error'}
                confirmBtnBsStyle={this.state.pop_msg ? 'success' : 'danger'}
                title={this.state.pop_msg ? this.state.pop_msg : this.state.pop_err}
                confirmBtnText={this.props.t('ok')}
                onConfirm={() => this.confirmPopup()}
              ></SweetAlert>
            ) : null}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateprops = (state) => {
  const { createPlcSafetyEventError, messagePlcSafetyEvent, loadingCreatePlcSafetyEvent } = state.createPlcSafetyEvent;
  const { zones } = state.getPlcSafetyZones;
  return { createPlcSafetyEventError, messagePlcSafetyEvent, loadingCreatePlcSafetyEvent, zones };
};

export default withRouter(
  connect(mapStateprops, { createPlcSafetyEvent, getPlcSafetyZones })(withNamespaces()(CreatePlcSafetyEventForm)),
);
